import { useQuery } from 'react-query';
import { AssessmentCommentResponse } from './assessmentCommentsTypes';
import { getAssessmentCommentsList } from './assessmentCommentsService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: AssessmentCommentResponse) => void;
    mapper?: (
        data?: AssessmentCommentResponse
    ) => M | AssessmentCommentResponse | undefined;
    enabled?: boolean;
    questionId: string;
};

const defaultMapper = (data?: AssessmentCommentResponse) => data;

export const useGetAssessmentCommentList = <M = AssessmentCommentResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    questionId,
}: Props<M>) => {
    const query = useQuery<AssessmentCommentResponse, Error>(
        ['assessmentComments'],
        () => getAssessmentCommentsList(questionId),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
